import { useState } from 'react';
import './NewsletterSection.css';
import { useNewsletter } from '../hooks/useNewsletter';

const iconDiscover = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='28' height='28' viewBox='0 0 24 24' fill='none' stroke='%23679509' stroke-width='1.5' stroke-linecap='round'%3E%3Ccircle cx='12' cy='12' r='10'/%3E%3Cpolygon points='16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76'/%3E%3C/svg%3E";
const iconSearch = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='28' height='28' viewBox='0 0 24 24' fill='none' stroke='%23679509' stroke-width='1.5' stroke-linecap='round'%3E%3Ccircle cx='11' cy='11' r='8'/%3E%3Cline x1='21' y1='21' x2='16.65' y2='16.65'/%3E%3C/svg%3E";

const features = [
  { icon: iconDiscover, title: "Descubrir", desc: "Descubre los mejores eventos cerca de ti y vive nuevas experiencias cada día." },
  { icon: iconSearch, title: "Buscar", desc: "¿Buscas qué hacer? Explora eventos únicos y encuentra tu próximo plan ideal." },
];

export default function NewsletterSection() {
  const { email, setEmail, loading, message, success, subscribe } = useNewsletter();

  return (
    <section className="boletin">
      <div className="boletin__inner">
        <div className="boletin__grid">
          <div className="boletin__text">
            <h2 className="boletin__title">
              Eleva tu Presencia.<br />Únete a la Lista VIP.
            </h2>
            <p className="boletin__description">
              Recibe acceso prioritario a preventas, acceso a zonas exclusivas en los venues y recomendaciones personalizadas de nuestros curadores locales.
            </p>
            <form className="boletin__form" onSubmit={subscribe}>
              <div className="boletin__input-wrap">
                <input
                  className="boletin__input"
                  type="email"
                  placeholder="Tu correo electrónico"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>
              <button className="boletin__submit" type="submit" disabled={loading}>
                {loading ? 'Enviando...' : 'Suscribirse'}
              </button>
            </form>
            {message && (
              <p className={`boletin__message ${success ? 'boletin__message--ok' : 'boletin__message--err'}`}>
                {message}
              </p>
            )}
          </div>
          <div className="boletin__features">
            {features.map((f, idx) => (
              <div className="tarjeta-beneficio" key={idx}>
                <div className="tarjeta-beneficio__icon">
                  <img src={f.icon} alt={f.title} />
                </div>
                <h4 className="tarjeta-beneficio__title">{f.title}</h4>
                <p className="tarjeta-beneficio__desc">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
